import { render, staticRenderFns } from "./ScalapayLogo.vue?vue&type=template&id=5cabde79&"
import script from "./ScalapayLogo.vue?vue&type=script&lang=js&"
export * from "./ScalapayLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports